import getInitialQuery from '@/common-utils/components/renders/dataTable/utils/getInitialQuery';
import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export const usePushPaymentStore = create()(
    persist(
        (set) => ({
            queryPartners: getInitialQuery(),
            storeQueryPartners: (queryPartners) => set(() => ({ queryPartners: queryPartners })),

            queryNotifRules: getInitialQuery(),
            storeQueryNotifRules: (queryNotifRules) => set(() => ({ queryNotifRules: queryNotifRules }))
        }),
        {
            name: 'push-payment-storage'
        }
    )
);

export default usePushPaymentStore;